export default function Impressum() {
  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-10">
          Impressum
        </h1>

        <div className="space-y-8 text-foreground-700">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <div className="space-y-2">
              <p className="font-semibold text-foreground-900">Klosek Metallbau GmbH</p>
              <p>Römerweg 15</p>
              <p>58513 Lüdenscheid</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Kontakt
            </h2>
            <div className="space-y-2">
              <p>
                Telefon: <a href="tel:023515691455" className="hover:text-primary-500 transition-colors">02351 5691455</a>
              </p>
              <p>Fax: 02351 5691456</p>
              <p>
                E-Mail: <a href="mailto:info@klosek-metallbau.de" className="hover:text-primary-500 transition-colors">info@klosek-metallbau.de</a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Geschäftsführer
            </h2>
            <p>Arthur Klosek</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Umsatzsteuer-ID
            </h2>
            <p>
              HRB 8012 Amtsgericht Iserlohn
            </p>
            <p className="mt-2">DE 33257432474</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Berufshaftpflichtversicherung
            </h2>
            <p>
              Wir haben eine Berufshaftpflichtversicherung abgeschlossen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Streitschlichtung
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary-500 transition-colors"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p className="mt-3">
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="mt-3">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mt-3">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Urheberrecht
            </h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-3">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}